




import { Component, Vue } from 'vue-property-decorator';
import PensionUnitSelectionList from '@/components/PensionUnitSelection/PensionUnitSelectionList.vue';

@Component({
  components: {
    PensionUnitSelectionList,
  },
})
export default class PensionUnitSelections extends Vue {}
